import { contemTextoPesquisa } from "../Utils/pesquisaTexto";
import React, { useEffect, useMemo, useState } from "react";
import {
  Autocomplete,
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  MenuItem,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Tooltip,
  Typography,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import VisibilityIcon from "@mui/icons-material/Visibility";
import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  where,
} from "firebase/firestore";
import { useHistory } from "react-router-dom";
import Navbar from "../Components/Navbar/navbar";
import HistoricoCadastro from "../Components/HistoricoCadastro/HistoricoCadastro";
import { auth, db } from "../Config/firebase";
import { gerarSequencial, obterMaiorSequencial } from "../Utils/sequencial";
import { consultaTenantAtual , aplicarTenantAtual} from "../Utils/tenant";
import { atualizarDocumentoComMesclagem } from "../Utils/concorrenciaFirestore";

const hoje = () => new Date().toISOString().split("T")[0];

const METODOLOGIAS_POR_TIPO = {
  A:
    "O ensaio segue as prescrições das normas da ABNT:\n" +
    "√ ABNT NBR 13749 - Revestimento de paredes e tetos de argamassas inorgânicas - Especificação.\n" +
    "√ ABNT NBR 13528 - Revestimento de paredes de argamassas inorgânicas - Determinação da resistência de aderência à tração.",
  B:
    "O ensaio segue as prescrições das normas da ABNT:\n" +
    "√ ABNT NBR 13754 - Revestimento de paredes internas com placas cerâmicas e com utilização de argamassa colante - procedimento - Anexo A - Determinação da resistência de aderência de revestimentos cerâmicos assentados com argamassa colante.",
  C:
    "O ensaio segue as prescrições das normas da ABNT:\n" +
    "√ ABNT NBR 13755 - Revestimentos cerâmicos de fachadas e paredes externas com utilização de argamassa colante — Projeto, execução, inspeção e aceitação — Procedimento,",
  D:
    "O ensaio segue as prescrições das normas da ABNT:\n" +
    "√ ABNT NBR 13753 - Revestimento de paredes internas com placas cerâmicas e com utilização de argamassa colante - procedimento - Anexo A - Determinação da resistência de aderência de revestimentos cerâmicos assentados com argamassa colante.",
};

const normalizarTipoEnsaio = (tipo) => {
  if (["A", "B", "C", "D"].includes(tipo)) return tipo;
  return tipo === "placaQuadrada" ? "B" : "A";
};

const inicial = {
  codigo: "",
  dataRelatorio: hoje(),
  cliente: "",
  clienteId: "",
  obra: "",
  obraId: "",
  endereco: "",
  localEnsaio: "",
  dataColagem: "",
  dataEnsaio: "",
  idadeRevestimento: "N/I",
  tipoEnsaio: "A",
  textoMetodologia: METODOLOGIAS_POR_TIPO.A,
  quantidadeCorposProva: 12,
};

const dataBR = (v) =>
  v && v.includes("-") ? v.split("-").reverse().join("/") : v || "-";

const novoCP = (i) => ({
  numero: "",
  d1: "",
  d2: "",
  local: "",
  formaRuptura: "",
  percentualRuptura: "",
  rupturasPercentuais: {},
  cargaRuptura: "",
});

function proximoCodigo(lista) {
  const ano = new Date().getFullYear();

  const nums = lista
    .map((x) => String(x.codigo || "").match(/RE-AR-(\d+)\//))
    .filter(Boolean)
    .map((x) => Number(x[1]));

  return `RE-AR-${String(
    nums.length ? Math.max(...nums) + 1 : lista.length + 1
  ).padStart(4, "0")}/${ano}`;
}

export default function CadastroTracao() {
  const history = useHistory();

  const [ensaios, setEnsaios] = useState([]);
  const [carregandoLista, setCarregandoLista] = useState(true);
  const [clientes, setClientes] = useState([]);
  const [obras, setObras] = useState([]);
  const [cliente, setCliente] = useState(null);
  const [form, setForm] = useState(inicial);
  const [salvando, setSalvando] = useState(false);
  const [aberto, setAberto] = useState(false);
  const [editando, setEditando] = useState(null);
  const [filtro, setFiltro] = useState("");

  useEffect(() => {
    carregar();
  }, []);

  async function carregar() {
    const [e, c] = await Promise.all([
      getDocs(consultaTenantAtual(query(collection(db, "tblEnsaiosTracao"), orderBy("criadoEm", "desc")))),
      getDocs(consultaTenantAtual(query(collection(db, "clientes"), orderBy("nome", "asc")))),
    ]);

    setEnsaios(e.docs.map((x) => ({ id: x.id, ...x.data() })));
    setClientes(c.docs.map((x) => ({ id: x.id, ...x.data() })));
    setCarregandoLista(false);
  }

  async function carregarObras(clienteId) {
    if (!clienteId) {
      setObras([]);
      return;
    }

    const s = await getDocs(
      consultaTenantAtual(query(
        collection(db, "obras"),
        where("clienteId", "==", clienteId),
        orderBy("nome", "asc")
      ))
    );

    setObras(s.docs.map((x) => ({ id: x.id, ...x.data() })));
  }

  function novo() {
    setEditando(null);
    setCliente(null);
    setObras([]);
    setForm({
      ...inicial,
    });
    setAberto(true);
  }

  async function editar(item) {
    setEditando(item);

    const c = clientes.find((x) => x.id === item.clienteId) || null;

    setCliente(c);
    await carregarObras(item.clienteId);
    setForm({
      ...inicial,
      ...item,
      tipoEnsaio: normalizarTipoEnsaio(item.tipoEnsaio),
      textoMetodologia:
        item.textoMetodologia ??
        METODOLOGIAS_POR_TIPO[normalizarTipoEnsaio(item.tipoEnsaio)],
      quantidadeCorposProva: 12,
    });
    setAberto(true);
  }

  async function salvar(abrirAposSalvar = false) {
    if (!form.clienteId || !form.obraId || !form.dataEnsaio) {
      alert("Selecione cliente, obra e data do ensaio.");
      return;
    }

    setSalvando(true);

    try {
      const qtd = 12;

    const codigo = editando?.id
      ? form.codigo
      : form.codigo || (await gerarSequencial({
          chave: "tracao",
          escopo: new Date(form.dataRelatorio || form.dataEnsaio || new Date()).getFullYear(),
          formato: {
            padding: 4,
            ano: new Date(form.dataRelatorio || form.dataEnsaio || new Date()).getFullYear(),
            template: "RE-AR-{numero}/{ano}",
          },
          valorMinimo: obterMaiorSequencial(ensaios, /RE-AR-(\d+)\//),
        })).codigo;

    const dados = {
      ...form,
      codigo,
      quantidadeCorposProva: qtd,
      corposProva: Array.from(
        { length: qtd },
        (_, i) => form.corposProva?.[i] || novoCP(i)
      ),
      atualizadoEm: new Date(),
      atualizadoPor: auth.currentUser?.email || null,
    };

    let ensaioId = editando?.id || "";

    if (editando?.id) {
      await atualizarDocumentoComMesclagem({
        db,
        referencia: doc(db, "tblEnsaiosTracao", editando.id),
        original: editando,
        atual: { ...editando, ...dados },
        metadados: { atualizadoEm: dados.atualizadoEm, atualizadoPor: dados.atualizadoPor },
      });
    } else {
      const docRef = await addDoc(collection(db, "tblEnsaiosTracao"), aplicarTenantAtual({
        ...dados,
        criadoEm: new Date(),
        criadoPor: auth.currentUser?.email || null,
      }));
      ensaioId = docRef.id;
    }

    setAberto(false);
    await carregar();

    if (abrirAposSalvar && ensaioId) {
      history.push(`/app/resistencia-tracao/${ensaioId}`);
    }
    } finally {
      setSalvando(false);
    }
  }

  const lista = useMemo(
    () =>
      ensaios.filter((x) =>
        contemTextoPesquisa([x.codigo, x.cliente, x.obra, x.localEnsaio]
          .join(" ")
          .toLowerCase(), filtro.toLowerCase())
      ),
    [ensaios, filtro]
  );

  return (
    <>
      <Navbar />

      <Box sx={{ p: { xs: 2, md: 4 } }}>
        <Paper className="cabecalho-lista-cadastro" elevation={0}>
        <Typography variant="h6" fontWeight={700}>Resistência de aderência à tração</Typography>
        <Typography variant="body2" sx={{ mb: 2 }}>Ensaios de revestimentos de argamassa</Typography>
        <Stack direction={{ xs: "column", md: "row" }} spacing={2} mb={3}>
          <Button variant="contained" onClick={novo}>
            + Novo ensaio
          </Button>

          <TextField
            size="small"
            label="Pesquisar"
            value={filtro}
            onChange={(e) => setFiltro(e.target.value)}
            sx={{ flex: 1 }}
          />
        </Stack>
        </Paper>

        <Paper
          sx={{
            overflow: "auto",
            border: "1px solid #e2e8f0",
            boxShadow: "none",
          }}
        >
          <Table className="lista-cadastro-padrao" size="small">
            <TableHead>
              <TableRow>
                <TableCell>Código</TableCell>
                <TableCell>Cliente / Obra</TableCell>
                <TableCell>Data</TableCell>
                <TableCell>Local do ensaio</TableCell>
                <TableCell align="center">Ações</TableCell>
              </TableRow>
            </TableHead>

            <TableBody>
              {lista.map((item) => (
                <TableRow
                  hover
                  key={item.id}
                  sx={{ cursor: "pointer" }}
                  onClick={() => history.push(`/app/resistencia-tracao/${item.id}`)}
                >
                  <TableCell>{item.codigo}</TableCell>
                  <TableCell>
                    <div className="lista-dado-principal">{item.cliente || "-"}</div>
                    <div className="lista-dado-secundario">Obra: {item.obra || "-"}</div>
                  </TableCell>
                  <TableCell className="lista-dado-secundario">{dataBR(item.dataEnsaio)}</TableCell>
                  <TableCell className="lista-dado-destaque">{item.localEnsaio || "-"}</TableCell>

                  <TableCell align="center">
                    <Tooltip title="Visualizar relatório">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          history.push(`/app/resistencia-tracao/${item.id}?relatorio=true&origem=lista`);
                        }}
                      >
                        <VisibilityIcon sx={{ color: "primary.main" }} />
                      </IconButton>
                    </Tooltip>

                    <Tooltip title="Editar cadastro">
                      <IconButton
                        size="small"
                        onClick={(e) => {
                          e.stopPropagation();
                          editar(item);
                        }}
                      >
                        <EditIcon sx={{ color: "#0288d1" }} />
                      </IconButton>
                    </Tooltip>
                    <HistoricoCadastro colecao="tblEnsaiosTracao" documentoId={item.id} registro={item} />
                  </TableCell>
                </TableRow>
              ))}

              {carregandoLista && <TableRow><TableCell colSpan={5}><Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", gap: 1.5, py: 4 }}><CircularProgress /><Typography color="text.secondary">Carregando registros...</Typography></Box></TableCell></TableRow>}
              {!carregandoLista && !lista.length && (
                <TableRow>
                  <TableCell colSpan={5} align="center">
                    Nenhum ensaio cadastrado.
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </Paper>
      </Box>

      <Dialog
        open={aberto}
        onClose={() => setAberto(false)}
        fullWidth
        maxWidth="sm"
      >
        <DialogTitle>
          {editando ? "Editar ensaio" : "Novo ensaio de tração"}
        </DialogTitle>

        <DialogContent dividers>
          <Stack spacing={2} mt={1}>
            <TextField
              label="Código"
              value={form.codigo}
              onChange={(e) =>
                setForm({
                  ...form,
                  codigo: e.target.value,
                })
              }
            />

            <Autocomplete
              options={clientes}
              getOptionLabel={(o) => o?.nome || ""}
              isOptionEqualToValue={(a, b) => a.id === b.id}
              value={cliente}
              onChange={(_, v) => {
                setCliente(v);
                setForm({
                  ...form,
                  cliente: v?.nome || "",
                  clienteId: v?.id || "",
                  obra: "",
                  obraId: "",
                  endereco: "",
                });
                carregarObras(v?.id);
              }}
              renderInput={(p) => (
                <TextField {...p} label="Empresa solicitante" />
              )}
            />

            <TextField
              select
              label="Empreendimento/Obra"
              value={form.obraId || ""}
              disabled={!cliente}
              onChange={(e) => {
                const o = obras.find((x) => x.id === e.target.value);
                setForm({
                  ...form,
                  obraId: o?.id || "",
                  obra: o?.nome || "",
                  endereco: o?.endereco || "",
                });
              }}
            >
              {obras.map((o) => (
                <MenuItem key={o.id} value={o.id}>
                  {o.nome}
                </MenuItem>
              ))}
            </TextField>

            <TextField
              label="Endereço"
              value={form.endereco || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  endereco: e.target.value,
                })
              }
            />

            <TextField
              label="Localização dos ensaios"
              value={form.localEnsaio || ""}
              onChange={(e) =>
                setForm({
                  ...form,
                  localEnsaio: e.target.value,
                })
              }
            />

            <Stack direction="row" spacing={2}>
              <TextField
                fullWidth
                type="date"
                label="Data da colagem"
                InputLabelProps={{ shrink: true }}
                value={form.dataColagem || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dataColagem: e.target.value,
                  })
                }
              />

              <TextField
                fullWidth
                type="date"
                label="Data do ensaio"
                InputLabelProps={{ shrink: true }}
                value={form.dataEnsaio || ""}
                onChange={(e) =>
                  setForm({
                    ...form,
                    dataEnsaio: e.target.value,
                  })
                }
              />
            </Stack>

            <TextField
              select
              label="Tipo de ensaio"
              value={normalizarTipoEnsaio(form.tipoEnsaio)}
              onChange={(e) =>
                setForm({
                  ...form,
                  tipoEnsaio: e.target.value,
                  textoMetodologia: METODOLOGIAS_POR_TIPO[e.target.value],
                })
              }
            >
              <MenuItem value="A">Parede interna/externa ou piso - Pastilha redonda (diâmetro)</MenuItem>
              <MenuItem value="B">Parede interna - Placa quadrada (L × L)</MenuItem>
              <MenuItem value="C">Parede externa - Placa quadrada (L × L)</MenuItem>
              <MenuItem value="D">Piso - Placa quadrada (L × L)</MenuItem>
            </TextField>

            <TextField
              label="Quantidade de corpos de prova"
              type="number"
              value={12}
              InputProps={{ readOnly: true }}
            />
          </Stack>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setAberto(false)}>Cancelar</Button>
          <Button
            variant="contained"
            onClick={() => salvar(!editando)}
            disabled={salvando}
          >
            {salvando ? "Salvando..." : editando ? "Salvar" : "Salvar e abrir"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
}
